import React, { memo, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import { Switch } from 'react-router-dom';
import { useWhiteLabelContext } from 'src/providers/WhiteLabelProvider';

function RouteTransition({ location, children }) {
  const containerRef = useRef(null);
  const { state: whiteLabelState } = useWhiteLabelContext();
  const { isEnclosedMode } = whiteLabelState || {};

  useEffect(() => {
    if (!isEnclosedMode) {
      return;
    }

    const container = containerRef.current;
    if (container) {
      container.scrollTop = 0;
    }
    window.scrollTo(0, 0);
  }, [isEnclosedMode, location.pathname]);

  return (
    <TransitionContainer
      id="transition-container"
      ref={containerRef}
      sx={
        isEnclosedMode && {
          position: 'relative',
          minHeight: '100vh',
          overflowX: 'hidden',
          boxShadow: (theme) => theme.shadows[4],
          borderRadius: (theme) => theme.shape.borderRadius / 4,
        }
      }
    >
      <RouteWrapper>
        <Switch location={location}>{children}</Switch>
      </RouteWrapper>
    </TransitionContainer>
  );
}

RouteTransition.propTypes = {
  location: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
};

export default memo(RouteTransition);

// ########################################
// ### Styled Components
// ########################################

const TransitionContainer = styled('div')({
  position: 'static',
  width: '100%',
  minHeight: '100%',
});

const RouteWrapper = styled('div')({
  position: 'absolute',
  width: '100%',
  height: '100%',
});
